<template>
    <div class="billing-toggle">
        <!-- <div class="sr-only" aria-live="assertive" v-text="activeBilling + ' billing selected'"></div> -->
        <button class="billing-toggle__button flex" :class="toggled ? 'billing-toggle__button--active' : ''" @click.prevent="toggle()" aria-roledescription="" data-qa="billing-toggle">
            <span aria-hidden="true">Yearly</span>
            <div class="billing-toggle__switch">
                <span class="billing-toggle__slider"></span>
            </div>
            <span class="sr-only">Toggle Yearly Billing</span>
            <span aria-hidden="true">Monthly</span>
        </button>
    </div>
</template>

<script>
import * as Analytics from '@/Util/reporting.js';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        async toggle() {
            if (!this.disabled) {
                if (this.toggled) {
                    Analytics.pushToDataLayer({
                        event: 'click',
                        attributes: {
                            section: 'Buy Now Cart',
                            action: 'Billing Period Toggle',
                            event_label: 'Monthly',
                        },
                    });

                    this.$store.commit('setBillingPeriod', 'month');
                } else {
                    Analytics.pushToDataLayer({
                        event: 'click',
                        attributes: {
                            section: 'Buy Now Cart',
                            action: 'Billing Period Toggle',
                            event_label: 'Yearly',
                        },
                    });

                    this.$store.commit('setBillingPeriod', 'year');
                }
                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        }
    },
    computed: {
        toggled() {
            return this.$store.getters.isYearly;
        },
        activeBilling() {
            return this.$store.getters.billingPeriod;
        }
    },
};
</script>

<style lang="postcss" scoped>
    .billing-toggle {
        @apply relative items-center cursor-pointer justify-center;

        &__button {
            @apply relative items-center;

            &--active {
                .billing-toggle__switch {
                    @apply bg-green-default;
                }
                .billing-toggle__slider {
                    transform: translateX(calc(0%));
                }
            }
        }

        &__switch {
            @apply inline-block bg-gray-3 rounded-full relative overflow-hidden w-[53px] h-[30px] mx-2 cursor-pointer p-[3px];
        }

        &__checkbox {
            @apply sr-only;

            &:focus ~ .billing-toggle__switch {
                @apply border-blue-default;
            }
        }

        &__slider {
            @apply bg-white rounded-full block relative w-[24px] h-[24px] transition-transform ease-in-out duration-100;
            transform: translateX(100%);
            box-shadow: 0px 0.14867989718914032px 0.3861546814441681px 0px rgba(0, 0, 0, 0.0096), 0px 0.6541915535926819px 0.7995674014091492px 0px rgba(0, 0, 0, 0.0157), 0px 1.6057426929473877px 1.594591736793518px 0px rgba(0, 0, 0, 0.02), 0px 3px 3.5px 0px rgba(0, 0, 0, 0.0243), 0px 5.20379638671875px 6px 0px rgba(0, 0, 0, 0.0304), 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
        }
    }
</style>
